import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

export interface ErrorMessage {
  message: string
  email?: string
}

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {
  private errorMessageSubject = new BehaviorSubject<ErrorMessage | null>(null)

  setError(message: ErrorMessage): void {
    this.errorMessageSubject.next(message)
  }

  getError$(): Observable<ErrorMessage | null> {
    return this.errorMessageSubject.asObservable()
  }

  clearError(): void {
    this.errorMessageSubject.next(null)
  }

  constructor() {}
}
